import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

const CustomAgGrid = ({
  rowData,
  columnDefs,
  pagination = true,
  paginationPageSize = 10,
  className = "",
  style = {
    height: "500px",
    "--ag-border-color": "#ababab",
  },
  defaultColDef = {},
  gridOptions = {},
  onGridReady,
  ...props
}) => {
  // Default column definition qui peut être surchargé par les props
  const defaultColumnDefinition = {
    sortable: true,
    filter: true,
    resizable: false,
    flex: 1,
    minWidth: 100,
    ...defaultColDef,
  };

  // Options de base de la grille qui peuvent être surchargées
  const baseGridOptions = {
    suppressCellFocus: true,
    animateRows: true,
    ...gridOptions,
  };

  return (
    <div
      className={`ag-theme-quartz ${className} shadow-lg`}
      style={{
        width: "100%",
        height: "500px",
        ...style,
      }}
    >
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColumnDefinition}
        pagination={pagination}
        paginationPageSize={paginationPageSize}
        onGridReady={onGridReady}
        {...baseGridOptions}
        {...props}
      />
    </div>
  );
};

export default CustomAgGrid;
